import { SharePointService, UpdateService } from 'sp-office365-framework';

export class UpdateToVersion1030Component {
    constructor(
        private sharePointService: SharePointService,
        private _updateService: UpdateService
    ) {}

    run() {
        const promise = new Promise<void>(async (resolve, reject) => {
            const processStepList = this.sharePointService.web.lists.getByTitle(
                'Prozessschritte'
            );
            const tasktemplateList = this.sharePointService.web.lists.getByTitle(
                'Aufgabenvorlagen'
            );
            const taskTypeList = this.sharePointService.web.lists.getByTitle(
                'Aufgabentypen'
            );

            const promises = [
                // Add Field Prozessschritt to List Aufgabenvorlagen
                await new Promise<void>((resolve, reject) => {
                    processStepList
                        .select('Id')()
                        .then(
                            (processStepListProps) => {
                                this._updateService
                                    .runFunctionIfFieldNotExists(
                                        tasktemplateList,
                                        'Prozessschritt',
                                        () => {
                                            const promise = new Promise<void>(
                                                (resolve2, reject2) => {
                                                    // tasktemplateList.fields
                                                    //     .addLookup(
                                                    //         'Prozessschritt',
                                                    //         processStepListProps.Id.toString(),
                                                    //         'Title'
                                                    //     )
                                                    //     .then(
                                                    //         () => {
                                                    //             resolve2();
                                                    //         },
                                                    //         (error) => {
                                                    //             reject2(error);
                                                    //         }
                                                    //     );
                                                }
                                            );
                                            return promise;
                                        }
                                    )
                                    .then(
                                        () => {
                                            resolve();
                                        },
                                        (error) => {
                                            reject(error);
                                        }
                                    );
                            },
                            (error) => {
                                reject(error);
                            }
                        );
                }),
                // Add Field Aufgabentyp to List Aufgabenvorlagen
                await new Promise<void>((resolve, reject) => {
                    taskTypeList
                        .select('Id')()
                        .then(
                            (taskTypeListProps) => {
                                this._updateService
                                    .runFunctionIfFieldNotExists(
                                        tasktemplateList,
                                        'Aufgabentyp',
                                        () => {
                                            const promise = new Promise<void>(
                                                (resolve2, reject2) => {
                                                    // tasktemplateList.fields
                                                    //     .addLookup(
                                                    //         'Aufgabentyp',
                                                    //         taskTypeListProps.Id.toString(),
                                                    //         'Title'
                                                    //     )
                                                    //     .then(
                                                    //         () => {
                                                    //             resolve2();
                                                    //         },
                                                    //         (error) => {
                                                    //             reject2(error);
                                                    //         }
                                                    //     );
                                                }
                                            );
                                            return promise;
                                        }
                                    )
                                    .then(
                                        () => {
                                            resolve();
                                        },
                                        (error) => {
                                            reject(error);
                                        }
                                    );
                            },
                            (error) => {
                                reject(error);
                            }
                        );
                }),
            ];

            Promise.all(promises).then(
                () => resolve(),
                (error) => {
                    reject(error);
                }
            );
        });
        return promise;
    }
}
